import axios from "axios";
import url from "../config/urlServiceConfig";

const themeAPI = {
  getAll: () => axios.get(url.theme),
  getById: (id) => axios.get(`${url.theme}/${id}`),
  create: (body) => axios.post(url.theme, body),
  update: (body) => axios.put(url.theme, body),
  delete: (id) => axios.delete(`${url.theme}/${id}`)
};

export default themeAPI;
